import { Component, Input, OnInit } from '@angular/core';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-shorts-card',
  templateUrl: './shorts-card.component.html',
  styleUrls: ['./shorts-card.component.css']
})
export class ShortsCardComponent implements OnInit {

  @Input() cardID: number;
  @Input() cardTitle: string;
  @Input() videoData:any = [];
  noOfViews:any
  constructor(public selfLearnService: SelfLearnService) { }

  ngOnInit(): void {
    this.noOfViews = this.getNoOfViews();
  }

  displayTime(duration:any){
    return this.selfLearnService.secondsToTime(duration);
  }

  getNoOfViews(){
    return this.selfLearnService.generateRandomNumber(1000, 2000);
  }

  displayImage(url:any){
    return url?.replaceAll('https', 'http');
  }

}
